import React, { useState, useEffect, useCallback } from "react";
import Footer from "../common/Footer";
import { Link } from "react-router-dom";
import HeaderSales from "../common/HeaderSales";
import axios from "axios";
import * as Constants from "../Constants/index";
import { saveAs } from "file-saver";
import swal from "sweetalert";
import ResponsivePagination from "react-responsive-pagination";
import moment from "moment";
import Oval from "../../loader/CircleLoade";
import DatePicker from "react-datepicker";
import { useNavigate } from "react-router-dom";
import { Formik } from "formik";

export default function NewErrorQrTransReport() {
    const navigate = useNavigate();
    const [searchUser, setSearchUser] = useState("");
    const [totalPages, setTotalPages] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [limit] = useState(30);
    const [errors, setErrors] = useState({});
    const [results, setResults] = useState([]);
    const [searchRecord, setSearchRecord] = useState();
    const [loading, setLoading] = useState(false);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [qrCode, setQrCode] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const [filterStatus, setFilterStatus] = useState("");
    const [isFiltering, setIsFiltering] = useState(false);

    const formattedDate = moment(fromDate).format("YYYY-MM-DD HH:mm:ss");
    const formattedDate2 = moment(toDate).format("YYYY-MM-DD 23:59:59");
    const start = formattedDate.replace(/:/g, "%3A");
    const end = formattedDate2.replace(/:/g, "%3A");

    console.log("results", results);
    useEffect(() => {
        if (currentPage !== 1) {
            qrTransReport(searchUser);
            setIsFiltering(searchTerm.length > 0);
        } else {
            qrTransReport("");
        }
    }, [currentPage, searchTerm]);

    const qrTransReport = () => {
        let token = localStorage.getItem("token");
        let UserType = localStorage.getItem("user_type");
        if (!token) {
            navigate("/");
        } else {
            const searchByQr = searchTerm === "" ? "" : `code=${searchTerm}&`;
            const searchStatus = filterStatus === "" ? "" : `status=${filterStatus}&`;
            const searchUserN = searchUser === "" ? "" : `mobile=${searchUser}&`;
            const searchFromDate = fromDate === "" ? "" : `start=${start}&`;
            const searchToDate = toDate === "" ? "" : `end=${end}&`;
            if (fromDate !== "" && toDate === "") {
                swal({
                    text: "Please select to date",
                    icon: "error",
                    timer: 2000,
                    buttons: false,
                });
                return; // Return early if reason is not selected when status is 'reject'
            }
            if (fromDate === "" && toDate !== "") {
                swal({
                    text: "Please select from date",
                    icon: "error",
                    timer: 2000,
                    buttons: false,
                });
                return; // Return early if reason is not selected when status is 'reject'
            }
            if (
                fromDate !== "" &&
                toDate !== "" &&
                new Date(fromDate) > new Date(toDate)
            ) {
                swal({
                    text: "From date should be less than to date",
                    icon: "error",
                    timer: 2000,
                    buttons: false,
                });
                return; // Return early if "from" date is greater than or equal to "to" date
            }
            try {
                setLoading(true);
                axios
                    .get(
                        Constants.baseUrl +
                        `reports/qrTransReportNew/list?${searchUserN}${searchFromDate}${searchToDate}${searchByQr}userType=MEMBER&status=ERROR&limit=${limit}&page=${currentPage}`,
                        {
                            headers: {
                                Authorization: `Bearer ${token}`,
                                "Accept-Language": localStorage.getItem("langauge"),
                                appVersion: Constants.av,
                                platform: Constants.pt,
                                company: Constants.company,
                                program: Constants.program,
                            },
                        }
                    )
                    .then((res) => {
                        if (res.status === 201) {
                            console.log("dagaddsfdsfd......", res.data.output);
                            if (res.data.code === 10001 && res.data.output) {
                                setResults(res.data.output.results);
                                setTotalPages(res.data.output.totalPages);
                                setSearchRecord();
                                setLoading(false);
                            } else if (res.data.code === 12002) {
                                setLoading(false);
                                setSearchRecord(res.data.output.results);
                                setTotalPages(res.data.output.totalPages);
                            } else {
                                swal({
                                    text: res.data.msg,
                                    icon: "error",
                                    timer: 2000,
                                    buttons: false,
                                });
                            }
                        } else {
                            swal({
                                text: res.data.msg,
                                icon: "error",
                                timer: 2000,
                                buttons: false,
                            });
                        }
                    });
            } catch (error) {
                console.log(error);
            }
        }
    };
    const handleSearchQuery = (event) => {
        const input = event.target.value;
        if (/^\d*$/.test(input)) {
            setSearchUser(input);
        }
        if (event.target.value === "") {
            qrTransReport("");
            setSearchRecord();
        }
    };
    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            qrTransReport(searchUser);
        }
    };

    const download = () => {
        let token = localStorage.getItem("token");
        const searchByQr = searchTerm === "" ? "" : `code=${searchTerm}&`;
        const searchStatus = filterStatus === "" ? "" : `status=${filterStatus}&`;
        const searchUserN = searchUser === "" ? "" : `mobile=${searchUser}&`;
        const searchFromDate = fromDate === "" ? "" : `start=${start}&`;
        const searchToDate = toDate === "" ? "" : `end=${end}&`;
        // Check for required date fields
        if (fromDate === "" && toDate !== "") {
            swal({
                text: "Please select from date",
                icon: "error",
                timer: 2000,
                buttons: false,
            });
            return;
        }
        if (fromDate !== "" && toDate === "") {
            swal({
                text: "Please select to date",
                icon: "error",
                timer: 2000,
                buttons: false,
            });
            return;
        }
        if (
            fromDate !== "" &&
            toDate !== "" &&
            new Date(fromDate) > new Date(toDate)
        ) {
            swal({
                text: "From date should be less than to date",
                icon: "error",
                timer: 2000,
                buttons: false,
            });
            return;
        }

        setLoading(true);

        axios
            .get(
                `${Constants.baseUrl}reports/download/qrTransreportNew?userType=MEMBER&status=ERROR&${searchUserN}${searchByQr}${searchFromDate}${searchToDate}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Accept-Language": localStorage.getItem("language"),
                        appVersion: Constants.av,
                        platform: Constants.pt,
                        company: Constants.company,
                        program: Constants.program,
                    },
                    responseType: "blob", // Set the responseType to 'blob'
                    // params: params // Pass query parameters
                }
            )
            .then((res) => {
                setLoading(false);
                if (res.status === 200) {
                    const fileData = new Blob([res.data], { type: "text/csv" });
                    saveAs(fileData, "qrTransactionReports.csv");
                } else {
                    swal({
                        text: res.data.msg || "An error occurred",
                        icon: "error",
                        timer: 2000,
                        buttons: false,
                    });
                }
            })
            .catch((error) => {
                setLoading(false);
                console.log(error);
                swal({
                    text: "An error occurred while downloading the file",
                    icon: "error",
                    timer: 2000,
                    buttons: false,
                });
            });
    };

    // const filterSearch = results.filter((item) => {
    //     const searchTermLower = searchTerm.toLowerCase();
    //     // Check if 'item.user.code' matches the search term
    //     const isCodeMatch = item.code.toLowerCase().includes(searchTermLower);

    //     return isCodeMatch;
    //   });

    //   const handleFind = (e) => {
    //     setQrCode(e.target.value)
    //   }

    const handleFilterStatusChange = (e) => {
        setFilterStatus(e.target.value);
    };

    const resetHandle = useCallback(() => {
        setSearchUser("");
        setErrors({});
        setSearchRecord();
        setResults([]);
        setFromDate("");
        setToDate("");
        setSearchTerm("");
        setFilterStatus("");
        qrTransReport();
        setCurrentPage(1);
        setIsFiltering(false);
    }, []);

    return (
        <>
            {loading ? <Oval /> : null}
            <HeaderSales />
            <section class="blog-area pt182">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12 tab mb-20">
                            <ul class="nav nav-tabs" role="tablist">
                                <li role="presentation" class="active">
                                    <Link to="#Section1" role="tab" data-toggle="tab">
                                        Error QR Transaction Report
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 col-sm-12 col-xs-12">
                            <div class="all-single-blog rpt">
                                <div class="row clearfix mb-15">
                                    <div class="col-md-3 col-sm-12 col-xs-12">
                                        <div class="form-group has-float-label style-two">
                                            <label>
                                                Mobile No.<sup></sup>{" "}
                                            </label>
                                            <input
                                                className="form-control"
                                                placeholder="Mobile no."
                                                type="text"
                                                maxLength="10"
                                                value={searchUser}
                                                onChange={handleSearchQuery}
                                                onKeyDown={handleKeyDown}
                                            />
                                        </div>
                                    </div>
                                    {/* <div className="col-md-3 col-sm-12 col-xs-12">
                                        <div className="form-group has-float-label style-two">
                                            <label>
                                                Filter Status<sup></sup>
                                            </label>
                                            <select
                                                className="form-control2"
                                                value={filterStatus}
                                                onChange={handleFilterStatusChange}
                                            >
                                                <option value="">All</option>
                                                <option value="SUCCESS">SUCCESS</option>
                                                <option value="ERROR">ERROR</option>
                                            </select>
                                        </div>
                                    </div> */}

                                    <div class="col-md-3 col-sm-12 col-xs-12">
                                        <div class="form-group has-float-label style-two">
                                            <label>
                                                QR Details<sup></sup>{" "}
                                            </label>
                                            <input
                                                className="form-control"
                                                placeholder="QR Code"
                                                type="text"
                                                value={searchTerm}
                                                onChange={(e) => setSearchTerm(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md-3 col-sm-12 col-xs-12">
                                        <div class="form-group has-float-label style-two">
                                            <label>
                                                From Date<sup></sup>{" "}
                                            </label>
                                            <DatePicker
                                                selected={fromDate}
                                                onChange={(date) => setFromDate(date)}
                                                dateFormat="dd-MM-yyyy"
                                                className="form-control"
                                                id="Fromdate"
                                                showYearDropdown
                                                showMonthDropdown
                                                autoComplete="off"
                                                scrollableYearDropdown
                                                maxDate={new Date()}
                                                onKeyDown={(e) => e.preventDefault()} // Prevent manual input using keyboard
                                                onFocus={(e) => e.target.blur()} // Blur the input to prevent focus
                                                onClick={(e) => e.preventDefault()} // Preven
                                            />
                                        </div>
                                        {errors.fromDate && (
                                            <div className="error-message">{errors.fromDate}</div>
                                        )}
                                    </div>
                                    <div class="col-md-3 col-sm-12 col-xs-12">
                                        <div class="form-group has-float-label style-two">
                                            <label>
                                                To Date<sup></sup>{" "}
                                            </label>
                                            <DatePicker
                                                selected={toDate}
                                                onChange={(date) => setToDate(date)}
                                                dateFormat="dd-MM-yyyy"
                                                className="form-control"
                                                id="todate"
                                                showYearDropdown
                                                showMonthDropdown
                                                autoComplete="off"
                                                scrollableYearDropdown
                                                maxDate={new Date()}
                                                onKeyDown={(e) => e.preventDefault()} // Prevent manual input using keyboard
                                                onFocus={(e) => e.target.blur()} // Blur the input to prevent focus
                                                onClick={(e) => e.preventDefault()} // Preven
                                            />
                                        </div>
                                        {errors.toDate && (
                                            <div className="error-message">{errors.toDate}</div>
                                        )}
                                    </div>
                                    <div class="col-md-12 col-sm-12 col-xs-12 text-center">
                                        <div class="form-group has-float-label style-two">
                                            <label class="invisible" style={{ width: "100%" }}>
                                                hidden
                                            </label>
                                            <input
                                                type="button"
                                                class="btn login_btn"
                                                value="Search"
                                                id="btnSearch"
                                                onClick={() => qrTransReport(searchUser)}
                                            />
                                            <input
                                                type="button"
                                                class="btn login_btn"
                                                value="reset"
                                                id="btnReset"
                                                onClick={resetHandle}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="carrd1">
                                            <div class="card-header card-header-warning">
                                                <h4 class="card-title">
                                                    Error QR Transaction Report
                                                    {searchRecord === null ? (
                                                        ""
                                                    ) : (
                                                        <Link to="#" class="pull-right" onClick={download}>
                                                            <i class="fa fa-file-excel-o"></i> Export
                                                        </Link>
                                                    )}
                                                </h4>
                                            </div>
                                            <div class="card-body table-responsive">
                                                <table
                                                    class="table table-striped mb_01"
                                                    id="table-to-xls"
                                                >
                                                    <thead>
                                                        <tr>
                                                            <th>S.No</th>
                                                            <th>Sales Name</th>
                                                            <th>Member Name</th>
                                                            <th>Member Mobile</th>
                                                            <th>Register Date</th>
                                                            <th>State</th>
                                                            <th>Register From</th>
                                                            <th>Total Points</th>
                                                            <th>Scan Date</th>
                                                            <th>Brand</th>
                                                            <th>Cat. Code</th>
                                                            <th>Segment</th>
                                                            <th>Category</th>
                                                            <th>Sub Category</th>
                                                            <th>Name</th>
                                                            <th>Material Description</th>
                                                            <th>Color</th>
                                                            <th>QR Details</th>
                                                            <th>Status</th>
                                                            <th>Remark</th>
                                                            <th>Scan ID</th>
                                                            <th>Base Points</th>
                                                        </tr>
                                                    </thead>
                                                    {searchRecord === null ? (
                                                        <tbody>
                                                            <tr>
                                                                <td
                                                                    colSpan="11"
                                                                    style={{
                                                                        textAlign: "center",
                                                                        fontSize: "16px",
                                                                    }}
                                                                >
                                                                    No record found!
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    ) : (
                                                        <tbody>
                                                            {results.map((item, index) => {
                                                                const serialNumber =
                                                                    (currentPage - 1) * limit + index + 1;
                                                                const scanDate = moment(
                                                                    item.createDateTime
                                                                ).format("DD-MM-YYYY");
                                                                // const doj = moment(item.user.createDateTime, 'DD-MM-YYYY HH:mm').format('DD-MM-YYYY')
                                                                // const transTime = moment(item.createDateTime).format('DD-MM-YYYY')
                                                                return (
                                                                    <>
                                                                        <tr>
                                                                            <td>{serialNumber}</td>
                                                                            <td>{item[0]}</td>
                                                                            <td>{item[1]}</td>
                                                                            <td>{item[2]}</td>
                                                                            <td>{item[3]}</td>
                                                                            <td>{item[4]}</td>
                                                                            <td>{item[5]}</td>
                                                                            <td>{item[6]}</td>
                                                                            <td>{item[7]}</td>
                                                                            <td>{item[8]}</td>
                                                                            <td>{item[9]}</td>
                                                                            <td>{item[10]}</td>
                                                                            <td>{item[11]}</td>
                                                                            <td>{item[12]}</td>
                                                                            <td>{item[13]}</td>
                                                                            <td>{item[14]}</td>
                                                                            <td>{item[15]}</td>
                                                                            <td>{item[16]}</td>
                                                                            <td>{item[17]}</td>
                                                                            <td>{item[18]}</td>
                                                                            <td>{item[19]}</td>
                                                                            <td>{item[20]}</td>
                                                                        </tr>
                                                                    </>
                                                                );
                                                            })}
                                                        </tbody>
                                                    )}
                                                </table>
                                                {totalPages > 1 && !isFiltering && (
                                                    <ResponsivePagination
                                                        current={currentPage}
                                                        total={totalPages}
                                                        onPageChange={(page) => setCurrentPage(page)}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
}
